module.exports = __webpack_public_path__ + "media/lisette_home.37243e9f.wav";